var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppealCreationFail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.668 1.66699C17.5846 1.66699 18.3349 2.41642 18.335 3.33301V13.333C18.335 14.2497 17.5846 15 16.668 15H5.00098L1.66797 18.333L1.67676 3.33301C1.67685 2.41642 2.41835 1.66699 3.33496 1.66699H16.668ZM10.001 6.8584L7.14258 4L6 5.14355L8.85742 8.00098L6.00195 10.8574L7.14453 12L10.001 9.14355L12.8574 12L14 10.8574L11.1436 8.00098L14.002 5.14355L12.8594 4L10.001 6.8584Z",
    fill: "#14AC63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppealCreationFail);
export default __webpack_public_path__ + "static/media/AppealCreationFail.65e5581dcaf556ce9621cc42480396fe.svg";
export { ForwardRef as ReactComponent };